export default "__VITE_ASSET__4ae190b5__"